import React from "react";
import { Header, HEADER } from "@/ui/Header";

type Props = {
    title: string;
    onBack?: () => void;
    backIcon?: string;
    icon?: string;
    onTitleClick?: () => void;
    onIconClick?: () => void;
    headerRight?: React.ReactNode;
    /** 1264 기준 레이아웃 폭. 숫자(px) 또는 문자열("1012px") */
    width?: number | string;
    /** 헤더 아래(body) 영역에 추가로 줄 스타일 */
    bodyStyle?: React.CSSProperties;
    /** 최상위 래퍼에 줄 스타일 */
    wrapperStyle?: React.CSSProperties;
    /** 헤더 높이(기본: HEADER.H) */
    headerHeight?: number;
};

export function PageShell({
                              title,
                              onBack,
                              backIcon,
                              icon,
                              onTitleClick,
                              onIconClick,
                              headerRight,
                              width,
                              bodyStyle,
                              wrapperStyle,
                              headerHeight,
                              children,
                          }: React.PropsWithChildren<Props>) {
    const headerH = headerHeight ?? HEADER.H;
    const targetWidth =
        typeof width === "number" ? `${width}px` : width ?? "100%";

    return (
        <div
            style={{
                width: "100%",
                minHeight: "var(--app-lvh, 100vh)",
                display: "flex",
                justifyContent: "center",
                overflow: "hidden",
                ...wrapperStyle,
            }}
        >
            <div
                style={{
                    width: "100%",
                    maxWidth: targetWidth,
                    margin: "0 auto",
                    display: "grid",
                    gridTemplateRows: `${headerH}px minmax(0, 1fr)`,
                    gridTemplateAreas: `"header" "body"`,
                    boxSizing: "border-box",
                    overflowX: "hidden",
                }}
            >
                <div style={{ gridArea: "header" }}>
                    <Header
                        title={title}
                        onBack={onBack}
                        backIcon={backIcon}
                        icon={icon}
                        right={headerRight}
                        onTitleClick={onTitleClick}
                        onIconClick={onIconClick}
                    />
                </div>
                <div style={{ gridArea: "body", ...bodyStyle }}>{children}</div>
            </div>
        </div>
    );
}
